import { parsePositiveInt } from './inputValidation';

export const scopedTransactionSelect = (supabase, transactionId, userId) => {
  const id = parsePositiveInt(transactionId, 'ID de transacción');
  const uid = parsePositiveInt(userId, 'ID de usuario');
  return supabase.from('transactions').select('*').eq('id', id).eq('user_id', uid);
};

export const scopedTransactionUpdate = (supabase, transactionId, userId, updates) => {
  const id = parsePositiveInt(transactionId, 'ID de transacción');
  const uid = parsePositiveInt(userId, 'ID de usuario');
  return supabase.from('transactions').update(updates).eq('id', id).eq('user_id', uid);
};
